<div class="p-4">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
  <div class="loader-overlay" *ngIf="isLoading">
    <p-progress-spinner ariaLabel="loading" />
  </div>

  <form
    [formGroup]="contractForm"
    novalidate
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="off"
  >
    <div class="card bg-white border-round">
      <div class="card-header p-3 ml-auto border-bottom-1 border-gray-200">
        <div class="flex items-center inline-block">
          <h2 class="m-0">Progressive Rebate Request</h2>
        </div>
        <div class="flex justify-content-end gap-2 inline-block">
          <p-button
            label="Download Template"
            icon="pi pi-download"
            (click)="downloadTemplate('assets/templates/contract-details-template.xlsx')"
            styleClass="p-button-help"
          ></p-button>
        </div>
      </div>
      <div class="card-body p-2 mt-3">
        <div class="grid formgrid p-fluid">
          <div class="col-12 md:col-6">
            <p-fileUpload
              p-fileupload
              mode="basic"
              name="contractFile"
              (onSelect)="onFileSelect($event)"
              [accept]="spreadsheetAcceptTypes"
              [maxFileSize]="maxFileSize"
              [showUploadButton]="false"
              [showCancelButton]="false"
              chooseLabel="Choose Files"
            >
            </p-fileUpload>
          </div>
          <!-- contract name required -->
          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-pencil"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <input
                  type="text"
                  pInputText
                  formControlName="contractName"
                  id="contractName"
                  class="w-full"
                  placeholder="Enter Contract name"
                  [ngClass]="{ 'p-invalid': isInvalid('contractName') }"
                />
                <label for="contractName">Contract Name<span class="requiredLable">*</span></label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <!-- customer required -->
          <!-- <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-users"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [options]="filteredCustomers"
                  formControlName="customer"
                  inputId="customer"
                  styleClass="w-full"
                  [filter]="true"
                  [fluid]="true"
                  [ngClass]="{ 'p-invalid': isInvalid('customer') }"
                >
                  <ng-template let-customer pTemplate="selectedItem">
                    <div *ngIf="customer">
                      {{ customer.customerNumber }} -
                      {{ customer.customerName }}
                    </div>
                  </ng-template>
                  <ng-template let-customer pTemplate="item">
                    <div>
                      {{ customer.customerNumber }} -
                      {{ customer.customerName }}
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter" let-customer>
                    <p-inputgroup>
                      <p-inputgroup-addon>
                        <i class="pi pi-search"></i>
                      </p-inputgroup-addon>
                      <input
                        #customerInput
                        type="text"
                        pInputText
                        placeholder="Filter"
                        (keyup)="filterCustomers($event)"
                      />
                      <p-button
                        type="button"
                        icon="pi pi-times"
                        (click)="customer.reset(); customerInput.value = ''"
                        styleClass="p-button-secondary"
                      ></p-button>
                    </p-inputgroup>
                  </ng-template>
                </p-dropdown>
                <label for="customer">Customer</label>
              </p-iftalabel>
            </p-inputgroup>
          </div> -->

          <!-- start date required -->
          <!-- <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="startDateActive"
                  [showIcon]="true"
                  inputId="startDateActive"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                  [maxDate]="yesterdayDate"
                   [inputStyleClass]="isInvalid('startDateActive') ? 'p-invalid' : ''"

                ></p-datePicker>
                <label for="startDateActive">Start Date<span class="requiredLable">*</span></label>
              </p-iftalabel>
            </p-inputgroup>
          </div> -->

          <!-- end date requird -->
          <!-- <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-calendar"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <p-datePicker
                  formControlName="endDateActive"
                  [showIcon]="true"
                  inputId="endDateActive"
                  class="w-full"
                  [appendTo]="'body'"
                  [style]="{ width: '100%' }"
                  [maxDate]="yesterdayDate"
                  [minDate]="contractForm.get('startDateActive')?.value"
                  [inputStyleClass]="isInvalid('endDateActive') ? 'p-invalid' : ''"

                ></p-datePicker>
                <label for="endDateActive">End Date<span class="requiredLable">*</span></label>
              </p-iftalabel>
            </p-inputgroup>
          </div> -->

          <div class="field col-12 md:col-6">
            <p-inputgroup>
              <p-inputgroup-addon>
                <i class="pi pi-building"></i>
              </p-inputgroup-addon>
              <p-iftalabel>
                <p-dropdown
                  [fluid]="true"
                  [options]="contractTypes"
                  formControlName="contractType"
                  optionLabel="label"
                  optionValue="value"
                  inputId="contractType"
                  class="w-full"
                  placeholder="Select Contract Type"
                  [ngClass]="{ 'p-invalid': isInvalid('contractType') }"
                ></p-dropdown>
                <label for="contractType">Contract Type<span class="requiredLable">*</span></label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <!-- note not required -->
          <div class="field col-6">
            <p-inputgroup>
              <p-inputgroup-addon
                ><i class="pi pi-pencil"></i
              ></p-inputgroup-addon>
              <p-iftalabel>
                <textarea
                  pInputTextarea
                  formControlName="note"
                  rows="3"
                  class="w-full"
                  inputId="note"
                  id="note"
                ></textarea>
                <label for="note">Note</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
        </div>
        <div class="flex justify-content-end gap-2 m-4 mt-6">
          <p-button
            label="Cancel"
            icon="pi pi-times"
            styleClass="p-button-secondary"
            (click)="onCancel()"
          ></p-button>
          <p-button
            label="Save"
            icon="pi pi-check"
            (click)="submitForm()"
            [loading]="isLoading"
          ></p-button>
        </div>
      </div>
    </div>
  </form>
</div>
